import React, { useEffect, useState } from "react";
import { Users, BookOpen, Trophy, Award } from "lucide-react";
import { adminApi, apiError } from "../../lib/api";
import { toast } from "sonner";

const CARDS = [
  { key: "total_users", label: "Usuarios", icon: Users, color: "#3B7DF6", bg: "#E5EFFF" },
  { key: "total_temas", label: "Temas", icon: BookOpen, color: "#22A860", bg: "#E2F6EB" },
  { key: "total_ligas", label: "Ligas", icon: Trophy, color: "#E9A400", bg: "#FBF0CE" },
  { key: "total_insignias", label: "Insignias", icon: Award, color: "#7C4DDB", bg: "#EEE6FB" },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.stats().then(setStats).catch((e) => toast.error(apiError(e)));
  }, []);

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-[#0A1C30]">Dashboard</h1>
      <p className="text-[#6B7688] mt-1">Resumen general de Supera Leadership.</p>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} className="bg-white rounded-2xl p-6 ring-1 ring-black/5">
              <span className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: c.bg }}>
                <Icon className="w-6 h-6" style={{ color: c.color }} />
              </span>
              <div className="mt-4 text-3xl font-extrabold text-[#0A1C30]">{stats ? stats[c.key] : "—"}</div>
              <div className="text-sm text-[#6B7688]">{c.label}</div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 bg-white rounded-2xl p-6 ring-1 ring-black/5">
        <h2 className="text-lg font-extrabold text-[#0A1C30]">Inscripciones por programa</h2>
        <div className="mt-5 space-y-3">
          {stats && Object.entries(stats.by_program).map(([name, count]) => {
            const max = Math.max(1, ...Object.values(stats.by_program));
            return (
              <div key={name} className="flex items-center gap-4">
                <span className="w-44 text-sm font-semibold text-[#2A3446] flex-shrink-0">{name}</span>
                <div className="flex-1 h-3 rounded-full bg-[#EDF0F4] overflow-hidden">
                  <div className="h-full rounded-full bg-[var(--gold)]" style={{ width: `${(count / max) * 100}%` }} />
                </div>
                <span className="w-10 text-right text-sm font-extrabold text-[#0A1C30]">{count}</span>
              </div>
            );
          })}
          {!stats && <p className="text-sm text-[#6B7688]">Cargando...</p>}
        </div>
      </div>
    </div>
  );
}
